export const KEYCLOAK_LOADED = 'itbi-cidadao/config/KEYCLOAK_LOADED';
